// Common styles for the basics guide visuals

import {styled} from 'styled-components';

import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {onboardingGuideRightSideWidth, onboardingGuideSlideHeight} from '../../guide/onboardingGuideHelpers';

export const StyledVisualContainer = styled.div`
  position: absolute;
  width: ${onboardingGuideRightSideWidth};
  height: ${onboardingGuideSlideHeight};
  overflow: hidden;
`;

export const StyledVisualLayout = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ${onboardingGuideRightSideWidth};
`;

export const StyledVisualDetailsText = styled.div`
  margin-top: 110px;

  font-size: ${fontSizes.large};
  line-height: 22px;
  color: ${(p) => p.theme.greys.shade70};
  width: 446px;
  text-align: center;

  span {
    color: ${(p) => p.theme.greys.shade90};
    font-weight: ${fontWeights.bold};
  }

  animation-name: basicsGuideDetailsTextFadeIn;
  animation-delay: 0s;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0;

  @keyframes basicsGuideDetailsTextFadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const StyledChannelCard = styled.div`
  width: 148px;
  height: 90px;
  border-radius: 12px;
  background: ${(p) => p.theme.greys.shade30};
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const ChannelCardIconPlaceHolder = styled.div`
  margin-top: 14px;
  margin-bottom: 8px;
  width: 40px;
  height: 40px;
`;

export const CardText = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.verySmall};
  line-height: 13px;
`;

export const StyledInboxCard = styled.div`
  width: 148px;
  height: 90px;
  border-radius: 12px;
  background: ${(p) => p.theme.greys.white};
  display: flex;
  align-items: center;
  flex-direction: column;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
`;

export const StyledInboxIcon = styled(Icon)`
  transform: scale(2);
  color: #006eb2;
  margin-top: 14px;
  margin-bottom: 8px;
  height: 40px;
`;
